import React from 'react';
import { useDatabase } from 'components/database';
import { setModal } from 'actions';
import { POST } from 'utils/httpMethods';
import useRouter from '../../../useRouter';
import Spinner from '../../../Spinner';
import RipRecommendationForm from './Form';
import FailedModal from '../../../FailedModal';
import saveRecommendationSimulations from '../../../../utils/recommendations';

const addSimulationIdToBody = (body, simulationId) => {
    if (!simulationId) {
        return body;
    }

    const addToRecommendations = (recommendations) => {
        if (!Array.isArray(recommendations)) {
            return recommendations;
        }

        return recommendations.map((reco, index) => (0 === index ? { ...reco, simulationId } : reco));
    };

    if ('partner' === body.target) {
        return {
            ...body,
            partner: {
                ...body.partner,
                recommendationsCIF: addToRecommendations(body.partner && body.partner.recommendationsCIF),
            },
        };
    }

    if ('clientAndPartner' === body.target) {
        return { ...body, recommendationsCIFClientAndPartner: addToRecommendations(body.recommendationsCIFClientAndPartner) };
    }

    return { ...body, recommendationsCIF: addToRecommendations(body.recommendationsCIF) };
};

const handleSubmit = (body, dispatch, { id, database }) => {
    dispatch(setModal(() => <Spinner>Envoi de l&apos;email en cours...</Spinner>, false));

    return database.rips.syncChanges()
        .then(() => saveRecommendationSimulations(body, database, id))
        .then((simulationId) => POST(`/api/rips/${id}/sendToManager`, { body: addSimulationIdToBody(body, simulationId) }))
        .catch((error) => {
            dispatch(setModal(() => <FailedModal />, false));
            throw error;
        });
};

const Recommendation = () => {
    const {
        params: { id },
        navigate,
    } = useRouter();

    const database = useDatabase();

    return (
        <RipRecommendationForm
            id={id}
            overlay="recommendation"
            onSubmit={handleSubmit}
            history={navigate}
            database={database}
        />
    );
};

export default Recommendation;
